<template>
	<div class="breadcrumb_wrap">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item v-for="(item,index) in data" :key="index" :to="item.path">
				<span @click="handleClick(item, index)">{{ item.title}}</span>
			</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'Breadcrumb',
		props: {
			data: {
				type: Array,
				default: () => []
			}
		},
		methods: {
			handleClick(item ,index) {
				if(item.path) {
					this.$emit('changeRoute', index)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	// .breadcrumb_wrap {
	// 	display: flex;
	// 	align-items: center;
	// 	width: 100%;
	// 	box-sizing: border-box;
	// }
</style>
